import React from "react";
import { useTranslation } from "react-i18next";

export default function LanguageGate({ children, fallback = null, ns }) {
	const { ready } = useTranslation(ns, { useSuspense: false });
	return ready ? children : fallback;
}
